import { Modal } from "antd";

import style from "./style.module.scss";

import { GreenMailIcon } from "../../assets/greenMail";
import { PhoneIcon } from "../../assets/phone";
import { WhatsappIcon } from "../../assets/whatsapp";
import ContactInfoWithIcon from "../ContactInfoWithIcon";

import { phoneNumberFetcher } from "../../constants/phoneNumber";
import { storage, getUserEnemScore } from "../../utils/storage";
import { showContactPhoneNumber } from "../../vendor/ABTesting";
import { createEvent } from "../../vendor/eventTracker";

interface IContactModalProps {
	visible: boolean;
	setModalVisible: (visible: boolean) => void;
}

export const ContactModal = ({ visible, setModalVisible }: IContactModalProps) => {
	const contactDetail = (
		<>
			<span>Seg a Sex: 8h às 22h</span>
			<span>Sab: 9h às 16h</span>
		</>
	);
	const randomFactor = +storage.getItem("random_factor")!;
	const phoneNumber = phoneNumberFetcher(randomFactor);
	const isBuscaNota = (typeof window !== "undefined" && window.location.pathname.match(/busca-nota/)) || getUserEnemScore();

	const buscaNotaMessage = "Oii, Amigo Edu! Quero saber mais sobre o BUSCA NOTA. Pode me ajudar?";
	const msgParam = isBuscaNota ? `&text=${buscaNotaMessage}` : "";

	return (
		<Modal
			cancelButtonProps={{ hidden: true }}
			okButtonProps={{ hidden: true }}
			className={style.modal}
			maskClosable={true}
			visible={visible}
			onCancel={() => setModalVisible(false)}
			title="Fale com a gente!"
			width={478}
		>
			<div>
				{showContactPhoneNumber() && (
					<ContactInfoWithIcon isTel={true} contactDetail={contactDetail} contact="11 99709-3532" icon={<PhoneIcon fillOne="#6ABC42" />} />
				)}
				<ContactInfoWithIcon
					contactDetail={<>Número de atendimento somente pelo Whatsapp!</>}
					contact={phoneNumber}
					target="_blank"
					icon={<WhatsappIcon fillOne="#6ABC42" />}
					link={"https://api.whatsapp.com/send?phone=55" + phoneNumber.replace(/\(|\)| |-/g, "") + msgParam}
					onClick={() => {
						createEvent("open_whatsapp");
					}}
				/>
				<ContactInfoWithIcon
					link="mailto:contato@amigoedu.com.br"
					contact="contato@amigoedu.com.br"
					icon={<GreenMailIcon fillOne="#6ABC42" />}
				/>
			</div>
		</Modal>
	);
};
